// extracted by mini-css-extract-plugin
export default {"dot":"TbJnpKEAGmpTQyXQpQ8P"};